import { dbPut } from '../core/db.js';
import { state } from '../core/state.js';
import { $, $$, dayKey, esc, fmtDur, fromKey, startOfDay, uid } from '../core/text.js';
import { modal } from '../ui/modal.js';
import { toast } from '../ui/toast.js';
import { allActiveCards } from './dashboard.js';
import { removeExam } from './exams.js';

/* ══════════ Kalender ══════════ */
export const EVENT_TYPES = {
  klausur: { name: 'Klausur', cls: 'ev-klausur' },
  testat:  { name: 'Testat',  cls: 'ev-testat' },
  uebung:  { name: 'Übung',   cls: 'ev-uebung' },
};
export const saveCal = () => dbPut('meta', { key: 'calendar', value: state.cal });
export const eventsOn = (k) => state.cal.events.filter((e) => e.day === k).sort((a, b) => a.type.localeCompare(b.type));
export const isBlocked = (k) => state.cal.blocked.includes(k);
export async function addCalEvent(day, type, title) {
  state.cal.events.push({ id: uid(), day, type, title: title || EVENT_TYPES[type].name });
  await saveCal(); renderCalendar(); toast(`${EVENT_TYPES[type].name} eingetragen ✦`);
}
export async function removeCalEvent(id) {
  state.cal.events = state.cal.events.filter((e) => e.id !== id);
  await saveCal(); renderCalendar(); toast('Termin entfernt');
}
export async function toggleBlocked(k) {
  if (isBlocked(k)) state.cal.blocked = state.cal.blocked.filter((x) => x !== k);
  else state.cal.blocked.push(k);
  await saveCal(); renderCalendar();
}

export function renderCalendar() {
  const m = state.calMonth;
  $('#cal-month').textContent = m.toLocaleDateString('de', { month: 'long', year: 'numeric' });
  const first = new Date(m.getFullYear(), m.getMonth(), 1);
  const lead = (first.getDay() + 6) % 7;
  const days = new Date(m.getFullYear(), m.getMonth() + 1, 0).getDate();
  const exams = new Map(state.courses.filter((c) => c.examDate).map((c) => [c.examDate, c]));
  const dueByDay = {};
  for (const c of allActiveCards()) {
    if (!c.due) continue;
    const k = dayKey(new Date(Math.max(c.due, Date.now())));
    dueByDay[k] = (dueByDay[k] || 0) + 1;
  }
  let html = '<div class="cal-day blank"></div>'.repeat(lead);
  for (let d = 1; d <= days; d++) {
    const date = new Date(m.getFullYear(), m.getMonth(), d);
    const k = dayKey(date);
    const count = state.log.find((l) => l.day === k)?.count || 0;
    const lvl = count === 0 ? 0 : count < 10 ? 1 : count < 25 ? 2 : count < 50 ? 3 : 4;
    const evs = eventsOn(k);
    const blocked = isBlocked(k);
    // Kursklausur zusätzlich als Klausur-Punkt anzeigen
    const dots = [...evs.map((e) => e.type), ...(exams.get(k) ? ['klausur'] : [])].slice(0, 4)
      .map((t) => `<i class="ev-dot ${EVENT_TYPES[t].cls}"></i>`).join('');
    html += `<button class="cal-day ${blocked ? 'blocked' : 'd' + lvl} ${k === dayKey() ? 'today' : ''} ${k === state.calSel ? 'selected' : ''}"
      data-day="${k}" title="${blocked ? 'Kein Lerntag' : count + ' Karten'}">
      <span>${d}</span>
      ${count ? `<span class="n">${count}</span>` : blocked ? '<span class="n">frei</span>' : ''}
      ${dots ? `<span class="ev-dots">${dots}</span>` : ''}
      ${dueByDay[k] ? '<span class="due-mark"></span>' : ''}
    </button>`;
  }
  $('#cal-grid').innerHTML = html;
  $$('[data-day]').forEach((el) => { el.onclick = () => dayModal(el.dataset.day); });
  renderUpcoming();
}
/* Rechte Spalte: alle anstehenden Termine (Kurs-Klausuren + eingetragene Termine) */
export function renderUpcoming() {
  const host = document.getElementById('cal-upcoming'); if (!host) return;
  const today = startOfDay();
  const items = [];
  state.courses.filter((c) => c.examDate).forEach((c) => {
    if (fromKey(c.examDate).getTime() >= today) items.push({ day: c.examDate, type: 'klausur', title: c.name, exam: true, id: c.id });
  });
  state.cal.events.forEach((e) => { if (fromKey(e.day).getTime() >= today) items.push({ day: e.day, type: e.type, title: e.title, id: e.id }); });
  items.sort((a, b) => a.day.localeCompare(b.day));
  const btn = document.getElementById('cal-add-exam'); if (btn) btn.onclick = () => addTerminModal();
  if (!items.length) { host.innerHTML = '<p class="page-sub" style="margin:8px 0 0">Keine anstehenden Termine. Trag mit „＋ Termin" eine Klausur ein.</p>'; return; }
  host.innerHTML = items.map((it) => {
    const d = fromKey(it.day);
    const dd = d.toLocaleDateString('de', { day: '2-digit', month: '2-digit' });
    return `<div class="up-row" data-goday="${it.day}">
      <i class="ev-dot ${EVENT_TYPES[it.type].cls}"></i>
      <span class="up-date">${dd}</span>
      <span class="up-title">${esc(it.title)}${it.exam ? '' : ` · ${EVENT_TYPES[it.type].name}`}</span>
      <button class="up-x" title="Entfernen" data-up-rm="${it.id}" data-up-exam="${it.exam ? 1 : 0}">✕</button>
    </div>`;
  }).join('');
  host.querySelectorAll('[data-goday]').forEach((r) => {
    r.onclick = (e) => { if (e.target.closest('[data-up-rm]')) return; state.calMonth = fromKey(r.dataset.goday); dayModal(r.dataset.goday); };
  });
  host.querySelectorAll('[data-up-rm]').forEach((b) => {
    b.onclick = async (e) => { e.stopPropagation(); if (b.dataset.upExam === '1') await removeExam(b.dataset.upRm); else await removeCalEvent(b.dataset.upRm); };
  });
}
/* Tages-Popup: Termine eintragen/entfernen, Lern-Pause, Tagesstatistik */
export function dayModal(k) {
  state.calSel = k;
  const paint = () => {
    const exams = new Map(state.courses.filter((c) => c.examDate).map((c) => [c.examDate, c]));
    const entry = state.log.find((l) => l.day === k);
    const exam = exams.get(k);
    const dueN = allActiveCards().filter((c) => c.due && dayKey(new Date(Math.max(c.due, Date.now()))) === k).length;
    const evs = eventsOn(k);
    const blocked = isBlocked(k);
    const byCourse = entry?.byCourse ? Object.entries(entry.byCourse).map(([id, v]) => {
      const c = state.courses.find((x) => x.id === id);
      return `<div class="stat-row-head"><b>${esc(c?.name || 'Gelöschter Kurs')}</b><span>${v.count} Karten · ${fmtDur(v.ms)}</span></div>`;
    }).join('') : '';
    const evList = evs.map((e) => `<div class="ev-row">
        <i class="ev-dot ${EVENT_TYPES[e.type].cls}"></i>
        <span class="ev-name"><b>${EVENT_TYPES[e.type].name}</b>${e.title && e.title !== EVENT_TYPES[e.type].name ? ' · ' + esc(e.title) : ''}</span>
        <button class="mini-btn del" data-rmev="${e.id}" title="Entfernen">✕</button>
      </div>`).join('');
    return `
      ${exam ? `<div class="hint-box cal-exam-box"><b>📌 Kurs-Klausur: ${esc(exam.name)}</b>
        <div class="row-actions"><button class="btn-ghost tiny outline" data-rmexam="${exam.id}">Entfernen</button></div></div>` : ''}
      <div class="ev-block">
        <div class="ev-block-head">Termine an diesem Tag</div>
        ${evList || '<p class="page-sub">Noch nichts eingetragen.</p>'}
        <div class="ev-add">
          <div class="chips" id="ev-type-chips">
            <button class="chip active" data-evtype="klausur">Klausur</button>
            <button class="chip" data-evtype="testat">Testat</button>
            <button class="chip" data-evtype="uebung">Übung</button>
          </div>
          <div class="ev-add-row">
            <input class="input" id="ev-title" placeholder="Titel (optional, z. B. Mathe II)">
            <button class="btn-primary tiny" id="ev-add-btn">＋ Eintragen</button>
          </div>
        </div>
      </div>
      <label class="toggle block-toggle"><input type="checkbox" id="cal-block" ${blocked ? 'checked' : ''}> An diesem Tag kann ich nicht lernen (zählt nicht fürs Tagesziel)</label>
      <div class="stat-grid" style="margin:12px 0">
        <div class="stat-tile"><div class="stat-num">${entry?.count || 0}</div><div class="stat-lbl">gelernt</div></div>
        <div class="stat-tile"><div class="stat-num">${fmtDur(entry?.ms || 0)}</div><div class="stat-lbl">Lernzeit</div></div>
        <div class="stat-tile"><div class="stat-num">${dueN}</div><div class="stat-lbl">fällig</div></div>
      </div>
      ${byCourse || '<p class="page-sub">An diesem Tag nichts gelernt.</p>'}`;
  };
  const close = modal({
    title: fromKey(k).toLocaleDateString('de', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }),
    body: paint(), okText: 'Fertig', onOk: () => {},
  });
  const box = document.getElementById('modal-body');
  const rewire = () => {
    box.innerHTML = paint();
    let evType = 'klausur';
    box.querySelectorAll('#ev-type-chips .chip').forEach((el) => { el.onclick = () => { box.querySelectorAll('#ev-type-chips .chip').forEach((c) => c.classList.remove('active')); el.classList.add('active'); evType = el.dataset.evtype; }; });
    box.querySelector('#ev-add-btn').onclick = async () => { await addCalEvent(k, evType, box.querySelector('#ev-title').value.trim()); rewire(); };
    box.querySelector('#ev-title').onkeydown = (e) => { if (e.key === 'Enter') box.querySelector('#ev-add-btn').click(); };
    box.querySelector('#cal-block').onchange = async () => { await toggleBlocked(k); rewire(); };
    box.querySelectorAll('[data-rmev]').forEach((el) => { el.onclick = async () => { await removeCalEvent(el.dataset.rmev); rewire(); }; });
    const rm = box.querySelector('[data-rmexam]'); if (rm) rm.onclick = async () => { await removeExam(rm.dataset.rmexam); rewire(); };
  };
  rewire();
}
/* „＋ Termin"-Popup: Datum + Art + Titel wählen */
export function addTerminModal() {
  const today = dayKey();
  modal({
    title: 'Termin hinzufügen',
    okText: 'Eintragen',
    body: `<div class="field"><label>Datum</label><input class="input" type="date" id="tm-date" value="${today}"></div>
      <div class="field"><label>Art</label>
        <div class="chips" id="tm-type"><button class="chip active" data-evtype="klausur">Klausur</button><button class="chip" data-evtype="testat">Testat</button><button class="chip" data-evtype="uebung">Übung</button></div></div>
      <div class="field"><label>Titel (optional)</label><input class="input" id="tm-title" placeholder="z. B. Chemie 2"></div>`,
    onOk: async () => {
      const date = $('#tm-date').value; if (!date) { toast('Bitte ein Datum wählen'); return false; }
      const active = $('#tm-type .chip.active'); const type = active ? active.dataset.evtype : 'klausur';
      await addCalEvent(date, type, $('#tm-title').value.trim());
    },
  });
  $$('#tm-type .chip').forEach((el) => { el.onclick = () => { $$('#tm-type .chip').forEach((c) => c.classList.remove('active')); el.classList.add('active'); }; });
}

